import React, { Component } from 'react';
import { Button } from '@xo-union/tk-component-buttons';
import PropTypes from 'prop-types';
import style from './style.scss';
import { H4 } from '@xo-union/tk-ui-typography/lib/components/Header/index.cjs';

class GuidanceModule extends Component {
  constructor(props, context) {
    super(props, context);
    const { title, buttonText, buttonOnClick, children } = props;
    this.title = title;
    this.children = children;
    this.buttonText = buttonText;
    this.buttonOnClick = buttonOnClick;
  }

  render() {
    return (
      <div className={style.guidanceModule}>
        <H4 className={style.guidanceTitle}>{this.title}</H4>
        <div className={style.guidanceContent}>{this.children}</div>
        <Button size="md" color="secondary-alternative" onClick={this.buttonOnClick}>
          {this.buttonText}
        </Button>
      </div>
    );
  }
}

GuidanceModule.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonText: PropTypes.string.isRequired,
  buttonOnClick: PropTypes.func,
};

export default GuidanceModule;
